function initializeTrixAlignment() {
  const Trix = window.Trix;
  if (!Trix) return console.error("Trix not available");

  Trix.config.blockAttributes.alignLeft = {
    tagName: "align-left",
    parse: true,
    exclusive: true,
    nestable: false,
    group: "alignment",
  };

  Trix.config.blockAttributes.alignCenter = {
    tagName: "align-center",
    parse: true,
    exclusive: true,
    nestable: false,
    group: "alignment",
  };

  Trix.config.blockAttributes.alignRight = {
    tagName: "align-right",
    parse: true,
    exclusive: true,
    nestable: false,
    group: "alignment",
  };
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeTrixAlignment);
} else {
  initializeTrixAlignment();
}

document.addEventListener("trix-before-initialize", function () {
  const Trix = window.Trix;
  if (!Trix) return;

  // Directly modify existing dompurify config
  Trix.config.dompurify.ADD_TAGS = [
    ...(Trix.config.dompurify.ADD_TAGS || []),
    "align-left",
    "align-center",
    "align-right",
  ];

  // Optionally add attributes if needed
  Trix.config.dompurify.ADD_ATTR = [
    ...(Trix.config.dompurify.ADD_ATTR || []),
    "class",
    "style", // if required for persistence
  ];
});

document.addEventListener("trix-initialize", (event) => {
  const editor = event.target.editor;
  const toolbar = event.target.toolbarElement;
  const trixElement = event.target;

  applyAlignmentInlineStyles(trixElement);

  if (
    toolbar &&
    !toolbar.querySelector('[data-trix-button-group="alignment-tools"]')
  ) {
    const group = document.createElement("span");
    group.className = "trix-button-group";
    group.setAttribute("data-trix-button-group", "alignment-tools");
    group.innerHTML = `
      <button type="button" class="trix-button trix-button--icon trix-button--icon-align-left" data-trix-attribute="alignLeft" title="Align Left" tabindex="-1">Align Left</button>
      <button type="button" class="trix-button trix-button--icon trix-button--icon-align-center" data-trix-attribute="alignCenter" title="Align Center" tabindex="-1">Align Center</button>
      <button type="button" class="trix-button trix-button--icon trix-button--icon-align-right" data-trix-attribute="alignRight" title="Align Right" tabindex="-1">Align Right</button>
    `;

    const buttonRow = toolbar.querySelector(".trix-button-row");
    if (buttonRow) {
      buttonRow.insertBefore(
        group,
        buttonRow.querySelector('[data-trix-button-group="block-tools"]')
      );
    }
  }

  ["alignLeft", "alignCenter", "alignRight"].forEach((attr) => {
    const btn = toolbar.querySelector(`[data-trix-attribute="${attr}"]`);
    if (btn && !btn.dataset.alignmentBound) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        editor.activateAttribute(attr);
        setTimeout(() => applyAlignmentInlineStyles(trixElement), 10);
      });
      btn.dataset.alignmentBound = "true";
    }
  });
});

document.addEventListener("trix-change", (event) => {
  applyAlignmentInlineStyles(event.target);
});

function applyAlignmentInlineStyles(root) {
  if (!root) return;
  ["left", "center", "right"].forEach((align) => {
    root.querySelectorAll(`align-${align}`).forEach((el) => {
      el.style.textAlign = align;
      el.style.display = "block";
      el.style.width = "100%";
    });
  });
}
